/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["cc-white-block[_ngcontent-%COMP%]{grid-gap:1.5rem;justify-content:center;text-align:center}cc-white-block[_ngcontent-%COMP%]:last-child{padding-bottom:3rem}.description[_ngcontent-%COMP%]{font-size:18px}cc-container[_ngcontent-%COMP%]{display:grid;grid-gap:1rem}#file[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
